import React, {Component} from 'react';
import {Form, Control, Errors} from 'react-redux-form';
import _ from 'lodash';
import {required} from "../field_validations";
import DateTimePick from "../forms/datetimepicker";
import Loading from "../loading";
import {confirmAlert} from "react-confirm-alert";

export default class ProjectPhasesEditForm extends Component{
	render(){
		const { projects } = this.props;
		const {phases_groups} = projects;
		let pu = _.find(projects.permissions, (o) => {return o==='Update'});
		return(
			<div className="columns is-centered">
				<div className="column">
					{this.state.phaseEditShow ? <PhaseEditModal active={this.state.phaseEditShow} closeModal={() => this._toggleModal()} {...this.props}/> : ''}
					<table className="inm-table">
						<thead>
						<tr>
							<th>ID</th>
							<th>Proceso</th>
							<th>Sub-Proceso</th>
							<th>Documento</th>
							<th>Fecha de inicio</th>
							<th>Fecha de última modificacióin</th>
						</tr>
						</thead>
						<tbody>
						{_.map(phases_groups,(row, key) => {
							return [
								<tr key={key}>
									<td>
										{pu ?
										<div className="actions">
											<button type="button" style={{cursor: 'pointer'}} onClick={() => this._editGroupPhase(row)}><i className="fa fa-edit"/></button>
											<button type="button" style={{cursor: 'pointer'}} onClick={() => this._getConfirm(row.id,row.version_phase.phase_group.name)}><i className="fa fa-trash-o"></i></button>
										</div>:''}
										{row.version_phase.id}
									</td>
									<td colSpan="2" style={{align:'center'}}><span>{row.version_phase.phase_group.name}</span></td>
									<td>{!_.isEmpty(row.documents) ?
										<ul>
											{_.map(row.documents, (item,d) => {
												return (
													<li key={d}>
														<a href={item.file} target="_blank" className="has-text-primary">
															<span className="icon"><i className="fa fa-link"/></span>{item.name}
														</a>
													</li>
												)
											})}
										</ul>:'---'}</td>
									<td style={{width: '15%'}}><span>{row.start_date}</span></td>
									<td style={{width: '15%'}}><span>{row.end_date}</span></td>
								</tr>,
								_.map(row.version_phase.project_version_phases,(phase, k) => {
									//let document = _.find(row.documents,{documentable_subtype: phase.version_phase.phase.slug})
									console.log('phase===>', phase.version_phase);
									//console.log('documents===>', row.documents);
									//console.log('document===>', document);
									return (
										<tr key={`phases-${k}`}>
											<td>
												{pu ?
												<div className="actions">
													<button type="button" style={{cursor: 'pointer'}} onClick={() => this._editPhase(phase, row.id)}><i className="fa fa-edit"/></button>
												</div>:''}
												{phase.version_phase.id}
											</td>
											<td >&nbsp;</td>
											<td ><span>{phase.version_phase.phase ? phase.version_phase.phase.name:'---'}</span></td>
											<td>---</td>
											<td ><span>{phase.start_date}</span></td>
											<td ><span>{phase.end_date}</span></td>
										</tr>
									)
								})
							]
						})}
						</tbody>
					</table>
					<br/>
					<div className="field is-grouped is-grouped-right">
						<div className="control">
							<button type="button" className="button is-large" onClick={() => this.props.history.push(`/proyectos`)}>Regresar</button>
						</div>
					</div>
				</div>
			</div>
		)
	}

	constructor(){
		super();
		this.state = {
			phaseEditShow: false
		}

	}

	_getConfirm(id, name){
		confirmAlert({
			title: '¿Está seguro?',
			message: `¿Estás seguro/(a) de eliminar el proceso "${name}"?`,
			confirmLabel: 'Aceptar',
			cancelLabel: 'Cancelar',
			onConfirm: () => this.props.projectPhaseDelete(this.props.match.params.id,id)
		})
	}

	_editGroupPhase(data){
		this.props.change(`projects.edit`,{
			type: 'group_phase',
			name: data.version_phase.phase_group.name,
			id: data.id,
			start_date: data.start_date,
			end_date: data.end_date
		});

		this.setState({
			phaseEditShow: true
		})
	}

	_editPhase(data, groupId){
		this.props.change(`projects.edit`,{
			type: 'phase',
			group_id: groupId,
			name: data.version_phase.phase.name,
			id: data.id,
			start_date: data.start_date,
			end_date: data.end_date
		});

		this.setState({
			phaseEditShow: true
		})
	}

	_toggleModal() {
		this.setState({
			phaseEditShow: false
		});

		this.props.reset('projects.edit');
	}
}

class PhaseEditModal extends Component{
	render(){
		let {projects} = this.props;
		return(
			<div className={`modal${this.props.active ? ' is-active' : ''}`}>
				<div className="modal-background" onClick={this.props.closeModal}></div>
				<div className="modal-content">
					<div className="message">
						<header className="message-header">
							<p>{projects.edit && projects.edit.type=== 'phase' ? `Sub-Proceso - ${projects.edit.name}`:`Proceso - ${projects.edit.name}`}</p>
							<button type="button" onClick={this.props.closeModal} className="delete"
							        aria-label="close"></button>
						</header>
						{projects.edit.isFetching ? <Loading/>:
						<Form model="projects.edit" className="message-body" style={{height: 'inherit'}} onSubmit={(values) => this._submitForm(values)} onSubmitFailed={() => this.props.setSystemNotification('¡Oh no!', 'Hay errores en el formulario', 'danger')}>
							<div className="field is-grouped">
								<div className="control is-expanded">
									<label htmlFor="start_date" className="label">Fecha de inicio <span className="small has-text-danger">*</span></label>
									<Control.text model=".start_date" name="start_date" id="start_date" component={DateTimePick} className="input" errors={{required}} validateOn="change"/>
									<Errors model=".start_date" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'La fecha es obligatorio'}}/>
								</div>

								<div className="control is-expanded">
									<label htmlFor="end_date" className="label">Fecha de última modificacióin </label>
									<Control.text model=".end_date" name="end_date" id="end_date" component={DateTimePick} className="input"/>
								</div>
							</div>

							<div className="field is-grouped is-grouped-right">
								<div className="control">
									<button type="button" className="button" onClick={this.props.closeModal}>Cerrar</button>
								</div>
								<div className="control">
									<Control.button model="projects.edit" type="submit" className="button is-primary" disabled={this._validateSave()}>Guardar</Control.button>
								</div>
							</div>
							<p className="has-text-grey has-text-right is-small">Los campos indicados con <span className="small has-text-danger">*</span> son obligatorios.</p>
						</Form>}
					</div>
				</div>
			</div>
		)
	}

	componentWillReceiveProps(newprops){
		let {edit} = newprops.projects;
		if(edit !== this.props.projects.edit){
			if(edit.action){
				if(edit.action === 'close'){
					this._putInfo(edit);
				}
			}
		}
	}

	_putInfo(data){
		let {projects} = this.props;

		let groupIndex = undefined; let phaseIndex = undefined;

		if(projects.edit.type === 'group_phase'){
			groupIndex = _.findIndex(projects.phases_groups, {id: projects.edit.id})
			this.props.change(`projects.phases_groups[${groupIndex}]`,{
				...projects.phases_groups[groupIndex],
				...data
			})
		}else {
			let groupIndex = _.findIndex(projects.phases_groups, {id: projects.edit.group_id})
			phaseIndex = _.findIndex(projects.phases_groups[groupIndex].version_phase.project_version_phases, {id: projects.edit.id})
			this.props.change(`projects.phases_groups[${groupIndex}].version_phase.project_version_phases[${phaseIndex}]`,{
				...projects.phases_groups[groupIndex].version_phase.project_version_phases[phaseIndex],
				...data
			})
		}

		this.props.closeModal();
	}

	_submitForm(values) {
		//console.log('values: ',values);
		this.props.projectPhaseSave(this.props.match.params.id, values);
	}

	_validateSave(){
		const {projects} = this.props;
		let pu = _.find(projects.permissions, (o) => {return o==='Update'});

		if(!_.isEmpty(projects.edit) && projects.edit.id){
			if(pu){
				return false;
			}else {
				return true;
			}
		}else {
			return true;
		}
	}
}


// WEBPACK FOOTER //
// ./src/elements/projects/phases.jsx